/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var ListCheckOutlineIcon = function ListCheckOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.70712 5.94981L5.82844 8.07113L10.0711 3.82849L11.4853 5.2427L5.82844 10.8996L2.29291 7.36403L3.70712 5.94981ZM12 18H20V16H12V18ZM20 10H12V8.00001H20V10ZM6.00002 16H8.00002V18H6.00002V16ZM4.00002 16C4.00002 14.8954 4.89545 14 6.00002 14H8.00002C9.10458 14 10 14.8954 10 16V18C10 19.1046 9.10458 20 8.00002 20H6.00002C4.89545 20 4.00002 19.1046 4.00002 18V16Z"
  }));
};
export default ListCheckOutlineIcon;